import useProject from '@hooks/useProject';

function useIsEmailSignIn() {
    const project = useProject();
    return project?.serviceCountry !== 'KR';
}

export default useIsEmailSignIn;
